import { forwardRef } from 'react';

export const HandShakeIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg
        ref={ref}
        width="49"
        height="48"
        viewBox="0 0 49 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_5184_362)">
          <path
            d="M13.4449 33.2468L14.9644 31.0309C15.4075 30.3978 15.2176 29.5747 14.6478 29.1948C14.0147 28.7516 13.1916 28.9416 12.8117 29.5114L11.2922 31.7273C10.849 32.3604 11.039 33.1835 11.6088 33.5634C12.1786 34.0066 13.0017 33.8799 13.4449 33.2468Z"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.7886 38.4385L22.3081 36.2225C22.7513 35.5894 22.5614 34.7663 21.9915 34.3865C21.3584 33.9433 20.5354 34.1332 20.1555 34.703L18.636 36.919C18.1928 37.5521 18.3827 38.3752 18.9525 38.755C19.5857 39.1982 20.4087 39.0083 20.7886 38.4385Z"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.9137 35.2726L18.1296 32.107C18.5728 31.4105 18.4462 30.4608 17.7497 30.0176L17.6231 29.9543C16.9267 29.5111 15.977 29.6378 15.5338 30.3342L13.3179 33.4998C12.8747 34.1963 13.0013 35.146 13.6977 35.5891L13.8244 35.6525C14.5208 36.0956 15.4072 35.969 15.9137 35.2726Z"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.5094 37.0458L20.7253 33.8801C21.1685 33.1837 21.0419 32.234 20.3454 31.7908L20.2188 31.7275C19.5224 31.2843 18.5727 31.411 18.1295 32.1074L15.9136 35.273C15.4704 35.9695 15.597 36.9191 16.2934 37.3623L16.4201 37.4256C17.0532 37.9321 18.0029 37.7422 18.5094 37.0458Z"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.8439 18.8753C32.6913 19.7617 30.602 18.4954 30.602 18.4954C27.3731 16.2162 21.3584 15.9629 18.9525 19.0652L15.9135 22.6741C15.217 23.4971 15.3437 24.7001 16.1667 25.3332C16.9898 26.0296 18.1927 25.903 18.8259 25.0799L21.9915 21.2179"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.12622 28.1819L11.5451 31.2209"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.0159 19.0018L13.571 17.6089"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.4998 29.1952L33.3246 33.3105C34.021 33.817 35.034 33.627 35.5405 32.9306C36.047 32.2342 35.8571 31.2212 35.1606 30.7147L22.0549 21.2178"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.98 31.9172L29.7787 34.703C30.4752 35.2095 31.4882 35.0196 31.9947 34.3231C32.5012 33.6267 32.3112 32.6137 31.6148 32.1072"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.5242 34.7663L26.93 36.4757C27.6265 36.9822 28.6395 36.7923 29.146 36.0958C29.6525 35.3994 29.4625 34.3864 28.7661 33.8799"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.9282 36.7925L23.7643 38.1221C24.524 38.6286 25.4737 38.502 25.9802 37.8055C26.4867 37.1091 26.2968 36.0961 25.6004 35.5896"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.2598 25.7128C29.1461 25.6495 30.3491 25.0797 30.7923 24.0667"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.6557 28.1819C39.6557 28.1819 37.1865 28.7517 35.4771 31.0309"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M47.0001 25.776L41.8718 28.1819L41.6819 28.2452C40.6689 28.7517 39.4026 28.3085 38.8961 27.2322L35.3506 19.698C34.8441 18.685 35.2873 17.4187 36.3636 16.9122L41.1121 14.5063"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.79492 25.3329L6.92324 27.7388L7.11318 27.8021C8.12618 28.3086 9.39243 27.8654 9.89893 26.7891L13.4444 19.1916C13.9509 18.1153 13.5077 16.9124 12.4314 16.4059L7.68299 14"
            stroke="#004B54"
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_5184_362">
            <rect width="48" height="48" fill="white" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
